"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonStyles = ({ theme }) => ({
    countBadge: {
        ".MuiBadge-badge": {
            top: 3,
            right: 3,
            height: 13,
            minWidth: 13,
            width: 13,
            fontSize: "0.65rem",
        },
    },
    divider: {
        height: "auto",
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    endAdornment: {
        marginLeft: theme.spacing(),
        height: "auto",
        alignItems: "stretch",
    },
    icon: {
        color: theme.palette.grey[500],
    },
    iconButton: {
        p: 1,
    },
    line: {
        display: "flex",
        // Height is grown by button
        flexGrow: 1,
    },
    paper: {
        alignItems: "center",
        // Take fullWidth
        flex: 1,
        // Align items vertically center
        display: "flex",
        height: 40,
        boxShadow: theme.shadows[1],
        // Give Paper the responsibility to set margin,
        // since we don't provide a button
        marginRight: theme.spacing(),
        // Keep the shadow while the Input is focused
        // NB: focus-within is not supported in IE or Edge
        "&:hover, &:focus, &:focus-within": {
            boxShadow: theme.shadows[3],
        },
        transition: theme.transitions.create("box-shadow", {
            duration: theme.transitions.duration.shorter,
        }),
        // Text cursor
        cursor: "text",
    },
    popover: {
        width: theme.spacing(40),
    },
    popoverLabel: {
        alignItems: "flex-start",
    },
    popoverTopBar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    popoverSubHeader: {
        margin: theme.spacing(1, 0),
    },
    startAdornment: {
        marginRight: theme.spacing(),
    },
});
exports.default = commonStyles;
